import React, { useState, useContext } from 'react';
import { Container, Form, Button, Alert, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import './Login.css';
import { useTranslation } from 'react-i18next'

// 九龍牛奶圖標 URL（這會在實際應用中替換為實際的本地圖片資源）
const logoSrc = '/logo2.png';

const Login = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [remember, setRemember] = useState(1);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!loginId || !password) {
      setError('請輸入登入名稱和密碼');
      return;
    }

    setLoading(true);

    try {
      const result = await login(loginId, password);

      // console.log(result);
      // navigate('/orders');

      if (result.success) {
        const delay = ms => new Promise(res => setTimeout(res, ms));
        await delay(300);
        i18n.changeLanguage('zh');
        navigate('/orders/new');
      } else {
        setError(result.message);
      }
    } catch (err) {
      if (err.response.data.message === 'msg_invalidUser') {
        setError(t('msg_invalidUser'));
      } else if (err.response.data.message === 'msg_inactive') {
        setError(t('msg_inactiveUser'));
      } else if (err.response.data.message === 'msg_wrongPassword') {
        setError(t('msg_wrongPassword'));
      } else {
        setError(err.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  if(localStorage.getItem('user') && localStorage.getItem('token')){
    navigate('/orders/new');
  }

  const handleRememberChange = (value) => {
    setRemember(value);
  };

  return (
    <Container className="login-container">
      <div className="login-card">
        <div className="text-center">
          <Image src={logoSrc} alt="KDL" className="login-logo" />
        </div>

        <h5 className="text-center mb-3">Online Order System</h5>

        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="User Name 登入名稱"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              disabled={loading}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control
              type="password"
              placeholder="Password 密碼"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check 
              type="checkbox" 
              label="Remember Me 記住我" 
              checked={remember === 1} 
              onChange={(e) => handleRememberChange(e.target.checked ? 1 : 0)}
            />
          </Form.Group>

          <Button
            variant="danger"
            type="submit"
            className="w-100 login-btn"
            disabled={loading}
          >
            {loading ? 'Signing in 登入中...' : 'Sign in 登入'}
          </Button>
        </Form>
      </div>
    </Container>
  );
};

export default Login;